import React, { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import sessionsService from '../../../services/sessionsServices';
import Toast from '../../Toast';

const RenameChatModal = ({ onClose, data }) => {
  const [title, setTitle] = useState(() => {
    if (!data?.title) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = data.title;
    return tempDiv.innerText.trim();
  });
  const queryClient = useQueryClient();

  const handleSubmit = useMutation({
    mutationFn: async e => {
      return await sessionsService?.updateSession({
        platform_id: 'chronolabs',
        session_id: data?.id,
        user_id: '123',
        agent_id: 'ferdy',
        title: e,
      });
    },
    retry: 1,
    onSuccess: response => {
      Toast({
        type: 'success',
        message: response.detail,
      });
      queryClient.invalidateQueries({ queryKey: ['sessions'] });
      onClose();
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div
        className="bg-white border border-shell-card-border rounded-xl p-6 w-full max-w-sm"
        onClick={e => e.stopPropagation()}>
        <h3 className="text-lg font-semibold text-[var(--text-color)] mb-4">Edit Chat Title</h3>
        <label className="text-sm text-muted mb-1.5 block">Chat Title</label>
        <input
          value={title}
          onChange={e => setTitle(e.target.value)}
          placeholder="Enter chat title"
          className="w-full bg-white border border-shell-card-border rounded-lg px-3 py-2 text-sm text-[var(--text-color)] placeholder:text-muted-faint outline-none focus:border-primary/40 mb-6"
        />
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="px-4 py-2 text-sm text-muted hover:text-[var(--text-color)]">
            Cancel
          </button>
          <button
            type="button"
            onClick={() => handleSubmit.mutate(title)}
            disabled={!title.trim() || handleSubmit.isPending}
            className="px-4 py-2 text-sm font-medium bg-primary hover:bg-primary/90 text-white rounded-lg disabled:opacity-50">
            {handleSubmit.isPending ? 'Updating...' : 'Update'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenameChatModal;
